module.exports = __webpack_public_path__ + "img/amazon.9a75adf2.png";